document.addEventListener("DOMContentLoaded", function() {
    var product = document.querySelector('.custom_product__container');
    var shopbar = document.querySelector('.shopbar');
    var footer  = document.querySelector('.footer ');
    const variantSelector = document.querySelectorAll('.shopBarInput');

    
  
    window.onscroll = function() {
        var productRect = product.getBoundingClientRect();
        var footerRect = footer.getBoundingClientRect();

        if (productRect.bottom < 200) {
            shopbar.classList.add('shopbar-active')
        } else {
            shopbar.classList.remove('shopbar-active')
        }

        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            shopbar.classList.remove('shopbar-active')
        }
    };
    
    variantSelector.forEach(function(variant) {
        variant.addEventListener('change', function() {
            const selectedVariant = document.querySelector('.selectedVariant');
            selectedVariant.innerHTML = `${variant.value} - Hot Chocolat`;
        });
    });

    function addProductToCart() {
       const addButton = document.querySelector('.product-form__submit');
       const btnShopBar = document.querySelector('.btn-shop-bar');

       
       btnShopBar.addEventListener('click', function() {
            addButton.click();
       });
    }

    addProductToCart();
});